export const FACEBOOK_LINK = 'https://www.facebook.com/101303324842387';
export const INSTAGRAM_LINK = 'https://www.instagram.com/decor22.vn/';
export const ZALO_LINK = 'https://zalo.me/3806197750712179356';
export const EMAIL_LINK = 'mailto:xinchao@artzy.vn';
